export const viewIndividualMemberFormDropdownConfigs = [
    { dropdownName: "SubscriptionStatus", fieldId: "accountStatusId" },
    { dropdownName: "ReasonForINSOL", fieldId: "reasonforLeavingId" },
    { dropdownName: "ReasonForINSOLForMembership", fieldId: "reasonId" },
    { dropdownName: "MembershipType", fieldId: "membershipTypeId" },
    { dropdownName: "MembershipTenure", fieldId: "membershipTensureId" },
    { dropdownName: "Country", fieldId: "placeofBirth" },
    { dropdownName: "Nationality", fieldId: "nationalityId" },
    { dropdownName: "Country", fieldId: "countryId" },
    { dropdownName: "HighestQualificationAttained", fieldId: "highestQualificationId" },
    { dropdownName: "Country", fieldId: "empCountryId" },
    { dropdownName: "MembershipType", fieldId: "membershipTypeName" },
    { dropdownName: "SubscriptionStatus", fieldId: "applicationStatus" },
    { dropdownName: "JobRole", fieldId: "jobRoleId" },
    { dropdownName: 'Salutation Id', fieldId: 'salutationId' },
]

export const viewIndividualMemberListFormDropdownConfigs = [
    { dropdownName: "MembershipTypeFilter", fieldId: "membershipTypeName" },
    { dropdownName: "SubscriptionStatus", fieldId: "applicationStatus" },
]

